module.exports = __webpack_public_path__ + "static/media/southchinasea.d8f07f22.svg";